import type { WalletAccount } from '@dynamic-labs-sdk/client';

import type { EvmWalletAccount } from '../../EvmWalletAccount.types';

/**
 * Type guard function to check if a wallet account is an EVM wallet account.
 *
 * @param walletAccount - The wallet account to check.
 * @returns True if the wallet account is an EVM wallet account, false otherwise.
 */
export const isEvmWalletAccount = (
  walletAccount: WalletAccount
): walletAccount is EvmWalletAccount => walletAccount.chain === 'EVM';
